import { addressFragment } from '~/graphql/fragments/address';

export const userFragment = gql`
    fragment userFragment on UserType {
        id
        uuid
        firstName
        lastName
        fullName
        email
        phone
        address {
            ...addressFragment
        }
        region {
            id
            name
        }
        skillset {
            id
            name
            order
        }
        accreditations {
            id
            name
        }
        qualificationDocuments {
            id
        }
        uniformEquipmentAllocations {
            id
            item {
                id
                name
            }
            quantity
            notes
            subtractStock
        }
        callSign {
            id
        }
        activeEvent {
            id
            name
            caseCategorySet {
                id
                triageEnabled
            }
        }
        tempUserEvent {
            id
        }
        staffId
        dateJoined
        lastLogin
        isActive
        isSuperuser
        isTempUser
        tempUserEvent {
            id
            name
            timeSheet {
                id
                dateTimeEnd
            }
        }
        permissions
        groups {
            id
        }
        canRegisterInterest
        twoFactorEnabled
        bypassQualificationRequirements
        bypassTwoFactorRequirements
        isMissingQualifications
        isMissingTwoFactor
        hasUsablePassword
    }
    
    ${addressFragment}
`;

export const tempUserFragment = gql`
    fragment tempUserFragment on TempUserType {
        id
        uuid
        firstName
        lastName
        fullName
        phone
        skillset {
            id
            name
            order
        }
        staffId
        isTempUser
        tempUserPin
        tempUserEvent {
            id
            name
        }
        permissions
        groups {
            id
        }
        lastLogin
        isActive
    }
`;
